<template>
  <div class="row mb-5">
    <div class="col-12">
      <div class="mb-4 d-flex align-middle">
        <h3>{{year}} User Payouts</h3>

        <SelectYear
          v-model="year"
          class="ml-auto"
        />
      </div>

      <table class="table table-hover">
        <thead class="thead-dark">
          <tr>
            <TableH
              label="First Name"
              queryKey="firstName"
            />
            <TableH
              label="Last Name"
              queryKey="lastName"
            />
            <TableH
              label="Email"
              queryKey="email"
            />
            <TableH
              :label="`${year} Payouts`"
              queryKey="payouts"
            />
            <TableH
              label="Tax Form Status"
              queryKey="hasFiledTaxForm"
            />
            <TableH
              label="Actions"
            />
          </tr>
        </thead>

        <tfoot v-if="isProcessing">
          <tr>
            <td colspan="6">
              <div class="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
              </div>
            </td>
          </tr>
        </tfoot>

        <tfoot v-else-if="error">
          <tr>
            <td colspan="6">
              <div
                class="alert alert-danger"
                role="alert"
              >
                {{getRequestError()}}
              </div>
            </td>
          </tr>
        </tfoot>

        <tfoot v-else-if="users.length === 0">
          <tr>
            <td colspan="6">
              <div
                class="alert alert-info"
                role="alert"
              >
                There're no Users matching the query.
              </div>
            </td>
          </tr>
        </tfoot>

        <tbody v-else>
          <UserRecord
            v-for="user in users"
            :key="user.id"
            :user="user"
            :year="year"
            @userUpdated="updateUser(user.id, $event)"
          />
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  import RequestMixin from '@/mixins/RequestMixin'

  import AdminAPI from '@/api/AdminAPI'

  import TableH from '@/components/TableH'

  import SelectYear from './SelectYear'
  import UserRecord from './UserRecord'

  export default {
    mixins: [
      RequestMixin,
    ],

    components: {
      TableH,
      SelectYear,
      UserRecord,
    },

    data() {
      return {
        users: [],
        year: moment().year(),
      }
    },

    methods: {
      async loadUsers() {
        this.users = await AdminAPI.getUsers({
          ...this.$route.query,
          year: this.year,
        })
      },

      async loadData() {
        this.handleRequest(this.loadUsers)
      },

      updateUser(userId, updatedUser) {
        this.users = this.users.map(user => {
          if (userId !== user.id)
            return user

          return updatedUser
        })
      },
    },

    watch: {
      year() {
        this.loadData()
      },

      $route() {
        this.loadData()
      },
    },

    mounted() {
      this.loadData()
    },
  }
</script>

<style lang="scss" scoped>
  table {
    table-layout: fixed;
  }
</style>
